import React, { Component } from "react";
import { Popover, Tooltip, FormControl, Input, FormHelperText, Divider, Button, IconButton, Icon, withStyles, Card, DialogContent, Dialog, DialogActions, DialogTitle, Typography, MenuItem, InputLabel, Radio, FormControlLabel, RadioGroup, Badge, Drawer } from "@material-ui/core";
import Grid, { default as MaterialGrid } from '@material-ui/core/Grid';

import Select from '@material-ui/core/Select';
import FilterListIcon from '@material-ui/icons/FilterList';
import CustomDropdown from '../../../components/CustomDropdown';
// import Chart from "react-google-charts";
import { DateRangePicker, DateRange } from "materialui-daterange-picker";
import moment from 'moment';//moment
import 'moment-timezone';//timezone
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'

import { Link } from "react-router-dom";
import * as actions from '../../../store/actions/index';
import { connect } from "react-redux";

class PipelineSummary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reportTitile: "Pipeline Summary ",
            reportSubTitle: " Summary of your pipeline by stage, based on Opportunity close date.",
            totalvalue: "$0 K",
            totalweight: "$0 K",
            totalopp: "3",
            selectedPipline: "1",
            selectedFilter: "1",
            value_type: "1",
            drawerOpen: false,
            dateopen: false,
            dateformat: 'MM/DD/YYYY',
            selectedDate: { from: moment().startOf("year").format('YYYY-MM-DD'), to: moment().endOf("year").format('YYYY-MM-DD') },
            selectedDatelabel: "",
            fromdate: moment().startOf("month").format('YYYY-MM-DD'),
            todate: moment().endOf('month').format('YYYY-MM-DD'),
            pipelineList: [],
            pipelinesummarydata: [],
            fieldDisplay: [],
            dropdownhide: [],
            systemTagsList: [],
            masterActivityTypesList: [],
            usersListArray: [],
            memberid: 0,
            crmOverview: {},
            dealsSummary: {},
        }
    }


    componentDidMount() {
        localStorage.removeItem('selected_report_pipeline_summary_filter_id');
        this.props.getPipelines(this.props.apolloClient.client);
        let fromDate = localStorage.getItem('dashboardFromDate');
        let toDate = localStorage.getItem('dashboardToDate');
        let val = { typeId: 4 }
        this.props.customFieldList(this.props.apolloClient.client, val);
        this.props.getTagsList(this.props.apolloClient.client);
        this.props.getUserList(this.props.apolloClient.client);
        this.props.getActivityTypes(this.props.apolloClient.client);
        this.setState({
            selectedDate: {
                from: moment().startOf("month").format('YYYY-MM-DD'),
                to: moment().endOf('month').format('YYYY-MM-DD')
            },
            fromdate: fromDate,
            todate: toDate
        }, () => this.updateGraphSettings())
    }



    componentWillReceiveProps(props) {
        if (props.settingReducer.userSettingArray && props.settingReducer.userSettingArray.data) {
            let usersetting = props.settingReducer.userSettingArray.data;
            this.setState({ dateformat: usersetting.dateformat, timeZone: usersetting.timezone })
        }

        if (props.settingReducer.masterActivityTypesList && props.settingReducer.masterActivityTypesList.is_loaded == true && props.settingReducer.masterActivityTypesList.data) {
            props.settingReducer.masterActivityTypesList.is_loaded = false
            var dataList = props.settingReducer.masterActivityTypesList.data;
            var count = dataList.filter(function (element) {
                if (element.is_disable == true) {
                    return element
                }
            });
            this.setState({
                masterActivityTypesList: dataList,
            });
        }

        if (props.settingReducer.pipelineListArray && props.settingReducer.pipelineListArray.data) {
            this.setState({ pipelineList: props.settingReducer.pipelineListArray.data })
        }

        if (props.settingReducer.usersListArray.data && this.state.usersListArray.length == 0) {
            const usersListArray = props.settingReducer.usersListArray.data;
            this.setState({ usersListArray: usersListArray })
        }

        if (props.reportReducer.reportPipelineSummary && props.reportReducer.reportPipelineSummary.data) {
            console.log("PipelineSummary API response:", props.reportReducer.reportPipelineSummary.data);
            let pipelinesummarydata = props.reportReducer.reportPipelineSummary.data.data

            let totalvalue = (pipelinesummarydata.totaloppamount && (pipelinesummarydata.totaloppamount > 0)) ? (pipelinesummarydata.totaloppamount) : 0;
            this.setState({
                pipelinesummarydata,
                totalweight: (pipelinesummarydata.totalOppWeight && (pipelinesummarydata.totalOppWeight > 0)) ? "$" + (pipelinesummarydata.totalOppWeight) : "$" + 0,
                totalvalue: "$" + totalvalue,
                totalopp: pipelinesummarydata.totalopportunities ? pipelinesummarydata.totalopportunities : 0,
                crmOverview: pipelinesummarydata.crmOverview || {},
                dealsSummary: pipelinesummarydata.dealsSummary || {},
            })

            // Parent ko crmOverview aur dealsSummary pass karo
            if (this.props.onPipelineData) {
                this.props.onPipelineData(
                    pipelinesummarydata.crmOverview || {},
                    pipelinesummarydata.dealsSummary || {}
                );
            }
        }

        if (props.settingReducer.systemTagsList.data && this.state.systemTagsList.length == 0) {
            const tagsData = props.settingReducer.systemTagsList.data;
            this.setState({ systemTagsList: tagsData })
        }

        // filter
        if (props.settingReducer.opportunitiesCustomFieldList.data) {
            const customFields = props.settingReducer.opportunitiesCustomFieldList.data;
            this.setState({ fieldsList: customFields })
        }
        if (props.reportReducer.UserDashboardId) {
            if (this.state.memberid !== props.reportReducer.UserDashboardId) {
                {
                    this.setState({
                        memberid: props.reportReducer.UserDashboardId
                    }, () => this.updateGraphSettings())
                }
            }
        }
    }
    handlePiplineChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        }, () => this.updateGraphSettings())
    }

    findWithAttr = (array, attr, value) => {
        for (var i = 0; i < array.length; i += 1) {
            if (array[i][attr] == value) {
                return i;
            }
        }
        return -1;
    }
    componentDidUpdate(PrevProps) {
        if (PrevProps.reportReducer.UserDashboardId !== this.props.reportReducer.UserDashboardId) {
            this.setState({
                memberid: this.props.reportReducer.UserDashboardId
            }, () => this.updateGraphSettings())
        }
    }
    updateGraphSettings = () => {
        let piplineparams = {
            filterdata: [],
            piplineid: parseFloat(this.state.selectedPipline),
            type: parseFloat(this.state.value_type),
            fromdate: this.state.fromdate,
            todate: this.state.todate,
            memberid: parseFloat(this.state.memberid)
        };
        this.props.piplineSummary(this.props.apolloClient.client, piplineparams);
    }
    render() {
        let { isOpenedFiltersDefault, filterlist, totalweight, pipelinesummarydata, pipelineList, selectedPipline, reportTitile, reportSubTitle, dateopen, selectedFilter, totalvalue, drawerOpen, totalopp, value_type } = this.state;
        let stages = [];
        let data = [];


        if (pipelinesummarydata && pipelinesummarydata.stage && pipelinesummarydata.graphval) {
            stages = pipelinesummarydata && pipelinesummarydata.stage;
            data = pipelinesummarydata && pipelinesummarydata.graphval;
        } else {
            let selectedStages = [];
            let pipelinekey = this.findWithAttr(pipelineList, 'id', selectedPipline);

            if (pipelinekey != -1) {
                selectedStages = pipelineList[pipelinekey].stage;
                selectedStages.map((stage, key) => {
                    stages.push(stage.name);
                    data.push(0);
                });
            }
        }
        const options = {
            chart: { type: 'column' },
            title: "",
            subtitle: "",
            xAxis: {
                title: {
                    text: null
                },
                categories: stages,
                crosshair: true
            },
            yAxis: {
                title: { text: null },
                min: 0,
                labels: {
                    formatter: function () {
                        return '$' + this.value;
                    }
                }
            },
            tooltip: {
                headerFormat: '<b><span style="font-size:14px">{point.key}</span></b><table>',
                pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                    '<td style="padding:0"><b>{point.y}</b></td></tr>',
                footerFormat: '</table>',
                shared: true,
                useHTML: true
            },
            legend: {
                enabled: false
            },
            plotOptions: {
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0
                }
            },
            series: [{
                color: "#2196f3",
                name: 'Total Value',
                data: data
            }]
        }


        // Premium Glassmorphic Styles
        const cardStyle = {
            background: "linear-gradient(135deg, rgba(255, 255, 255, 0.95), rgba(240, 248, 255, 0.8))",
            backdropFilter: "blur(16px)",
            borderRadius: "20px",
            border: "1px solid rgba(255, 255, 255, 0.6)",
            boxShadow: "0 10px 40px -10px rgba(31, 38, 135, 0.1)",
            overflow: "hidden",
            marginBottom: "28px"
        };

        const headerStyle = {
            padding: "24px 32px 16px",
            background: "linear-gradient(90deg, rgba(3, 169, 244, 0.08), rgba(0, 150, 136, 0.05))",
            borderBottom: "1px solid rgba(0, 0, 0, 0.03)"
        };

        const titleStyle = {
            margin: 0,
            fontSize: "1.4rem",
            fontWeight: 700,
            color: "#0288D1",
            fontFamily: "'Inter', sans-serif",
            letterSpacing: "-0.01em"
        };

        const linkStyle = {
            color: "#0288D1",
            textDecoration: "none",
            fontWeight: 600,
            fontSize: "0.9rem",
            padding: "8px 16px",
            borderRadius: "10px",
            background: "rgba(3, 169, 244, 0.1)",
            transition: "all 0.3s ease",
            display: "flex",
            alignItems: "center",
            gap: "4px"
        };

        const numberValueStyle = {
            fontSize: "2.5rem",
            fontWeight: 700,
            color: "#263238",
            fontFamily: "'Inter', sans-serif",
            letterSpacing: "-0.02em",
            display: "inline-block"
        };
        const numberLabelStyle = {
            fontSize: "0.9rem",
            color: "#607d8b",
            fontWeight: 600,
            display: "inline-block",
            marginLeft: "8px"
        };

        const statBoxStyle = {
            background: "rgba(255,255,255,0.85)",
            borderRadius: "14px",
            padding: "14px 18px",
            border: "1px solid rgba(2, 136, 209, 0.12)",
            boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
        };
        const statValueStyle = {
            fontSize: "1.7rem",
            fontWeight: 700,
            color: "#0288D1",
            fontFamily: "'Inter', sans-serif",
            letterSpacing: "-0.02em",
            lineHeight: 1.2,
        };
        const statLabelStyle = {
            fontSize: "0.78rem",
            fontWeight: 600,
            color: "#78909c",
            marginTop: "4px",
            textTransform: "uppercase",
            letterSpacing: "0.05em",
        };

        return (
            <Card elevation={0} style={cardStyle}>
                <div style={headerStyle}>
                    {/* Row 1: Title + View Report button */}
                    <Grid container justify="space-between" alignItems="center" style={{ marginBottom: "16px" }}>
                        <h3 style={titleStyle}>{reportTitile}</h3>
                        <Link
                            style={linkStyle}
                            to="/reports/report-default/"
                            onMouseOver={(e) => { e.currentTarget.style.background = "rgba(3, 169, 244, 0.2)"; e.currentTarget.style.transform = "translateY(-1px)" }}
                            onMouseOut={(e) => { e.currentTarget.style.background = "rgba(3, 169, 244, 0.1)"; e.currentTarget.style.transform = "none" }}
                        >
                            View Full Report <Icon style={{ fontSize: "1.1rem" }}>arrow_forward</Icon>
                        </Link>
                    </Grid>

                    {/* Row 2: 3 stat boxes */}
                    <Grid container spacing={2} style={{ marginBottom: "16px" }}>
                        <Grid item xs={3}>
                            <div style={statBoxStyle}>
                                <div style={statValueStyle}>{totalvalue}</div>
                                <div style={statLabelStyle}>Total Value</div>
                            </div>
                        </Grid>
                        <Grid item xs={3}>
                            <div style={statBoxStyle}>
                                <div style={statValueStyle}>{totalweight}</div>
                                <div style={statLabelStyle}>Total Weighted</div>
                            </div>
                        </Grid>
                        <Grid item xs={3}>
                            <div style={statBoxStyle}>
                                <div style={statValueStyle}>{totalopp}</div>
                                <div style={statLabelStyle}>Opportunities</div>
                            </div>
                        </Grid>
                        <Grid item xs={3} alignItems="center">
                            <CustomDropdown
                                label="Pipeline"
                                name="selectedPipline"
                                id="Pipeline"
                                value={selectedPipline}
                                onChange={this.handlePiplineChange}
                                formControlStyle={{ width: '150px', margin: 0 }}
                                style={{
                                    background: "rgba(255, 255, 255, 0.8)",
                                    borderRadius: "8px",
                                    fontWeight: 600,
                                    color: "#009688",
                                    fontSize: "0.95rem",
                                    width: '170px'
                                }}
                            >
                                <MenuItem value={"0"} style={{ fontWeight: 500 }}>All</MenuItem>
                                {pipelineList && pipelineList.map((pipeline, o) => (
                                    <MenuItem key={o} value={pipeline.id} style={{ fontWeight: 500 }}>{pipeline.name}</MenuItem>
                                ))}
                            </CustomDropdown>
                        </Grid>
                    </Grid>

                    {/* Row 3: Pipeline dropdown */}
                    {/* <Grid container alignItems="center">
                        <Grid item>
                            <CustomDropdown
                                label="Pipeline"
                                name="selectedPipline"
                                id="Pipeline"
                                value={selectedPipline}
                                onChange={this.handlePiplineChange}
                                formControlStyle={{ width: '180px', margin: 0 }}
                                style={{
                                    background: "rgba(255, 255, 255, 0.8)",
                                    borderRadius: "8px",
                                    fontWeight: 600,
                                    color: "#009688",
                                    fontSize: "0.95rem"
                                }}
                            >
                                <MenuItem value={"0"} style={{ fontWeight: 500 }}>All</MenuItem>
                                {pipelineList && pipelineList.map((pipeline, o) => (
                                    <MenuItem key={o} value={pipeline.id} style={{ fontWeight: 500 }}>{pipeline.name}</MenuItem>
                                ))}
                            </CustomDropdown>
                        </Grid>
                    </Grid> */}
                </div>
                <div style={{ padding: "20px 28px" }}>
                    <HighchartsReact
                        style={{ width: "100%" }}
                        highcharts={Highcharts}
                        options={options}
                    />
                </div>
            </Card>
        );
    }
}

const mapStateToProps = state => ({
    settingReducer: state.settingReducer,
    reportReducer: state.reportReducer,
    opportunityReducer: state.opportunityReducer,
    apolloClient: state.apolloClient,
    notification: state.notification,
});
const mapDispatchToProps = dispatch => {
    return {
        getPipelines: (client) => dispatch(actions.getPipelines(client)),
        getTagsList: (client) => dispatch(actions.getTagsList(client)),
        getUserList: (client) => dispatch(actions.getUserList(client)),
        getActivityTypes: (client) => dispatch(actions.getActivityTypes(client)),
        customFieldList: (client, value) => dispatch(actions.customFieldList(client, value)),

        piplineSummary: (client, value) => dispatch(actions.piplineSummary(client, value)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(PipelineSummary);